import React, { useEffect, useState } from "react";
import Modal from "components/Modal";
import { axiosInstance } from "store/auth";

export default function ManageComment(props) {
  const [data, setData] = useState();
  const [reply, setReply] = useState("");

  const fetchCommentData = async (id) => {
    if (!id) return;

    try {
      const response = await axiosInstance.get(`/comment-panel/data/${id}`);
      const result = response.data;

      if (result) {
        setData(result?.data);
      }
    } catch (error) {
      console.error("Error fetching comment data:", error);
    }
  };

  useEffect(() => {
    if (props.show && props.item?.id) {
      fetchCommentData(props.item.id);
    }
  }, [props.show, props.item?.id]);

  useEffect(() => {
    if (!props.show) {
      setReply("");
      setData(undefined);
    }
  }, [props.show]);

  const submitReply = () => {
    if (!reply.trim() || !props.reply) {
      return;
    }

    props.reply(reply.trim(), () => {
      setReply("");
      props.close?.();
    });
  };

  const commentContent =
    props?.item?.translations?.fa?.content ||
    props?.item?.translations?.en?.content;
  const authorName = props?.item?.author
    ? `${props?.item?.author?.translations?.fa?.name || ""} ${
        props?.item?.author?.translations?.fa?.lastName || ""
      }`.trim()
    : "";
  const relatedTitle =
    data?.refId?.translations?.title ||
    data?.refId?.translations?.fa?.title ||
    data?.refId?.translations?.en?.title ||
    "";

  return (
    <Modal show={props?.show} handleClose={props?.close} title={props?.title}>
      <div className="mt-3 text-center sm:mt-0 sm:mr-4 sm:text-right">
        <div className="mt-2">
          کاربر:
          <p className="text-sm text-gray-900">
            {authorName}
            <br />
          </p>
        </div>

        <br />

        <div className="mt-2">
          نظر:
          <p className="text-sm text-gray-900">{commentContent}</p>
        </div>

        <br />

        <div className="mt-2">
          برای:
          <p className="text-sm text-gray-900">
            {props?.item?.type}
            <br />
            {relatedTitle}
          </p>
        </div>

        {!props?.item?.isReplay && (
          <>
            <br />

            <div className="mt-2">
              پاسخ ادمین:
              <textarea
                value={reply}
                onChange={(e) => setReply(e.target.value)}
                rows={4}
                className="form-control mt-2"
                placeholder="متن پاسخ ادمین را وارد کنید"
              />
              <button
                type="button"
                disabled={props.load || !reply.trim()}
                onClick={submitReply}
                className="btn btn-primary mt-3"
              >
                ثبت پاسخ
              </button>
            </div>
          </>
        )}

        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            disabled={props.load}
            onClick={props.accept}
            className="btn btn-primary w-20 mr-1"
          >
            تایید
          </button>
          <button
            type="button"
            disabled={props.load}
            onClick={props.delete}
            className="btn btn-outline-secondary w-20 mr-1"
          >
            حذف
          </button>
          <button
            type="button"
            disabled={props.load}
            onClick={props.close}
            className="btn btn-outline-secondary w-20 mr-1"
          >
            بستن
          </button>
        </div>
      </div>
    </Modal>
  );
}
